module.exports = __webpack_public_path__ + "img/emoji_79.0cb81346.png";